import axios from "../utils/axiosConfig";

const institutionService = {
    getAll: async (params = {}) => {
        try {
            const response = await axios.get("/institutions", { params });
            return response.data;
        } catch (error) {
            console.warn("API Error, returning mock data", error);
        }
    },
    
    getById: async (id) => {
        try {
          const response = await axios.get(`/institutions/${id}`);
          return response.data;
        } catch (error) {
            console.warn("API Error, returning mock data", error);
        }
    },

    create: async (data) => {
        return axios.post("/institutions", data);
    },

    update: async (id, data) => {
        return axios.put(`/institutions/${id}`, data);
    },

    delete: async (id) => {
        return axios.delete(`/institutions/${id}`);
    },
};

export default institutionService;
